
import {
    GET_SYSTEM_USERS,
    GET_SYSTEM_USERS_SUCCESS,
    GET_SYSTEM_USERS_FAIL,
    ADD_NEW_SYSTEM_USER,
    ADD_NEW_SYSTEM_USER_SUCCESS,
    ADD_NEW_SYSTEM_USER_FAIL,
    UPDATE_SYSTEM_USER,
    UPDATE_SYSTEM_USER_SUCCESS,
    UPDATE_SYSTEM_USER_FAIL,
    DELETE_SYSTEM_USER,
    DELETE_SYSTEM_USER_SUCCESS,
    DELETE_SYSTEM_USER_FAIL,
} from "./actionTypes"

export const getSystemUsers = () => ({
    type: GET_SYSTEM_USERS,
})

export const getSystemUsersSuccess = users => ({
    type: GET_SYSTEM_USERS_SUCCESS,
    payload: users,
})

export const getSystemUsersFail = error => ({
    type: GET_SYSTEM_USERS_FAIL,
    payload: error,
})

export const addNewSystemUser = user => ({
    type: ADD_NEW_SYSTEM_USER,
    payload: user,
})

export const addNewSystemUserSuccess = user => ({
    type: ADD_NEW_SYSTEM_USER_SUCCESS,
    payload: user,
})

export const addNewSystemUserFail = error => ({
    type: ADD_NEW_SYSTEM_USER_FAIL,
    payload: error,
})

export const updateSystemUser = user => ({
    type: UPDATE_SYSTEM_USER,
    payload: user,
})

export const updateSystemUserSuccess = user => ({
    type: UPDATE_SYSTEM_USER_SUCCESS,
    payload: user,
})

export const updateSystemUserFail = error => ({
    type: UPDATE_SYSTEM_USER_FAIL,
    payload: error,
})

export const deleteSystemUser = id => ({
    type: DELETE_SYSTEM_USER,
    payload: id,
})

export const deleteSystemUserSuccess = id => ({
    type: DELETE_SYSTEM_USER_SUCCESS,
    payload: id,
})

export const deleteSystemUserFail = error => ({
    type: DELETE_SYSTEM_USER_FAIL,
    payload: error,
})
